import * as vp from 'vopay';
import { ExtendedNestedSubAccount } from '../OrgChartContainer';
import { Box, Card } from 'vopay';
import { Button, Title, CircleButton } from '@/components/UI';
import { useForm } from '@/components/Form/utils';
import { buildSubAccountRows } from './buildSubAccountRows.helper';
import usePostCreateSubAccount from '@/hooks/useApi/usePostCreateSubAccount';
import useDataFetchIndicator from '@/hooks/useDataFetchIndicator';
import { useAlertDialog } from '@/providers/AlertDialog.provider';
import { useTranslation } from 'react-i18next';

interface CreateSubAccountProps {
  node: ExtendedNestedSubAccount;
  onClose: () => void;
  onSuccess: () => void;
}

const CreateSubAccount: React.FC<CreateSubAccountProps> = ({ node, onClose, onSuccess }) => {
  const fieldDataList = buildSubAccountRows();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [, , , postCreateSubAccount] = usePostCreateSubAccount({});
  const alertDialog = useAlertDialog();
  const { t } = useTranslation('translations', { keyPrefix: 'SubAccounts.Create' });
  const { renderFormElements, ctx } = useForm<vp.CreateSubAccountRequest>({
    config: fieldDataList,
    initialValues: {
      LegalBusinessName: '',
      OriginatorName: '',
      OriginatorShortName: '',
      EmailAddress: '',
    },
    onSubmit: async (serializedData) => {
      try {
        setDataFetchingInfo(true);
        const resp = await postCreateSubAccount({
          ...serializedData,
          ParentAccountID: node.AccountID,
        });
        if (!resp.Success) {
          alertDialog.error(t('Form.creationErrorMessage'), resp.ErrorMessage);
        } else {
          onSuccess();
        }
      } finally {
        setDataFetchingInfo(false);
      }
    },
  });

  return (
    <Card hoverEffect={false} style={{ padding: '32px', backgroundColor: 'var(--vopayWhite)' }}>
      <div style={{ minWidth: '600px' }}>
        <Box flx="col" gapSize="24px">
          <Box flx="col" gapSize="15px">
            <Box jc="fe">
              <CircleButton onClick={onClose} icon="close" />
            </Box>
            <Title level="4">{t('title')}</Title>
          </Box>

          {renderFormElements({
            config: fieldDataList,
          })}
          <Button
            id="sub-account-creation-btn"
            onClick={() => {
              ctx.handleSubmit();
            }}
            disabled={!ctx.isValid}
            colorScheme="primary"
          >
            {t('Form.submitButton')}
          </Button>
        </Box>
      </div>
    </Card>
  );
};

export default CreateSubAccount;
